import React from 'react';

import PaymentConciliationAssginationDone from './Done';
import PaymentConciliationAssginationSuggested from './Suggested';

const PaymentConciliationAssgination = (props: any) => {
  const {
    payIn,
    setDocumentsSuggested,
    documentsSuggested,
    bigSetup,
    setOpen,
    pagination,
  } = props;

  return (
    <div>
      <div>
        <PaymentConciliationAssginationDone
          payIn={payIn}
          bigSetup={bigSetup}
          setOpen={setOpen}
          pagination={pagination}
        />
      </div>
      <div style={{ padding: '20px 0px' }}>
        {payIn.status !== 'Conciliado' && (
          <PaymentConciliationAssginationSuggested
            payIn={payIn}
            setDocumentsSuggested={setDocumentsSuggested}
            documentsSuggested={documentsSuggested}
            bigSetup={bigSetup}
            setOpen={setOpen}
          />
        )}
      </div>
    </div>
  );
};

export default PaymentConciliationAssgination;
